export class ReportSettings {
    PageSize: number;
    PageSizeDetail: number;
    PageBreakPerGroup: boolean;

    ExpandDetail: boolean;

    StripedLines: boolean;
    DisableStripedLinesOnDetail: boolean;

    Orientation: OrientationEnum;
}

export enum OrientationEnum {
    Portrait = 1,
    Landscape = 2
}
